(function(){
  var root = document.getElementById('contact');
  if(!root) return;
  var form = root.querySelector('.contact-form') || root.querySelector('form');
  if(!form) return;

  var checks = [
    { id: 'f-name',  err: 'err-name',  test: function(v){ return v.trim() !== ''; }, msg: '請留下您的稱呼，方便我們稱呼您。' },
    { id: 'f-tel',   err: 'err-tel',   test: function(v){ return v.trim() !== ''; }, msg: '請留下聯絡電話，我們才能回覆您。' },
    { id: 'f-tel',   err: 'err-tel',   test: function(v){ return /[0-9]{8,}/.test(v.replace(/[\s-]/g,'')); }, msg: '電話號碼看起來不太對，請確認位數。' },
    { id: 'f-email', err: 'err-email', test: function(v){ return v.trim() !== ''; }, msg: '請留下 Email，方便我們回覆您。' },
    { id: 'f-email', err: 'err-email', test: function(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }, msg: 'Email 格式看起來不太對，請再確認一次。' }
  ];

  function errEl(field){
    var id = field.getAttribute('aria-describedby');
    return id ? document.getElementById(id) : null;
  }
  function setError(field, el, message){
    if(field.parentElement) field.parentElement.classList.add('has-error');
    if(el) el.textContent = message;
    field.setAttribute('aria-invalid', 'true');
  }
  function clearError(field){
    if(!field) return;
    if(field.parentElement) field.parentElement.classList.remove('has-error');
    var el = errEl(field);
    if(el) el.textContent = '';
    field.removeAttribute('aria-invalid');
  }

  // 輸入時即時清除錯誤
  ['f-name','f-tel','f-email'].forEach(function(id){
    var f = document.getElementById(id);
    if(f) f.addEventListener('input', function(){ clearError(f); });
  });

  form.addEventListener('submit', function(e){
    var firstInvalid = null;
    // 先清空既有錯誤
    ['f-name','f-tel','f-email'].forEach(function(id){ clearError(document.getElementById(id)); });

    for(var i = 0; i < checks.length; i++){
      var c = checks[i];
      var field = document.getElementById(c.id);
      if(!field) continue; // 欄位不存在則略過，不阻擋送出
      if(field.parentElement && field.parentElement.classList.contains('has-error')) continue; // 同欄位已報錯不重複
      if(!c.test(field.value)){
        setError(field, document.getElementById(c.err), c.msg);
        if(!firstInvalid) firstInvalid = field;
      }
    }

    // 僅在驗證失敗時阻擋；通過則交由 Shopify 原生 POST
    if(firstInvalid){
      e.preventDefault();
      firstInvalid.focus();
    }
  });
})();
